module.exports = __webpack_public_path__ + "static/media/InstantBuy-round.f9308a60.png";